import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
var TimelineHeader = React.memo(function () { return (_jsxs("div", { className: "timeline__header", children: [_jsx("div", { className: "timeline__accent" }), _jsxs("h2", { className: "timeline__title", children: ["\u0418\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435", _jsx("br", {}), "\u0434\u0430\u0442\u044B"] })] })); });
TimelineHeader.displayName = 'TimelineHeader';
export default TimelineHeader;
